import { Component } from "react";
import { withRouter } from "react-router-dom";

class ScrollToTop extends Component {
  // componentDidMount() {
  // 	document.addEventListener('locale-change', this.top);
  // }

  // componentWillUnmount() {
  // 	document.removeEventListener('locale-change', this.top);
  // }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.top();
    }
  }

  top() {
    window.scrollTo(0, 0);
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/modules/common/components/app/ScrollTop.js